import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { CesButtonSecondaryComponent } from '../ces-buttons/ces-button-secondary.component';
import { CesButtonTertiaryComponent } from '../ces-buttons/ces-button-tertiary.component';
import { CesButtonComponent } from '../ces-buttons/ces-button.component';
import { ButtonSize } from '../ces-buttons/interfaces';
import { CesFloatingBarComponent } from '../ces-floating-bar/ces-floating-bar.component';

@Component({
  selector: 'ces-bottom-actions',
  imports: [CesButtonComponent, CesButtonTertiaryComponent, CesButtonSecondaryComponent, CesFloatingBarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ces-bottom-actions.component.html',
})
export class CesBottomActions implements OnInit {
  @Input() cancelLabel: string = '';
  @Input() validateLabel: string = '';
  @Input() secondaryLabel?: string;

  private readonly translate = inject(TranslocoService);

  ngOnInit() {
    if (!this.cancelLabel) {
      this.cancelLabel = this.translate.translate('common.buttons.cancel');
    }
    if (!this.validateLabel) {
      this.validateLabel = this.translate.translate('common.buttons.validate');
    }
  }
  @Input() cancelIcon: string = '';
  @Input() validateIcon: string = '';
  @Input() secondaryIcon: string = '';
  @Input() cancelDisabled: boolean = false;
  @Input() validateDisabled: boolean = false;
  @Input() secondaryDisabled: boolean = false;
  @Input() buttonSize: ButtonSize = 'small';

  @Output() discard = new EventEmitter<void>();
  @Output() validate = new EventEmitter<void>();
  @Output() secondary = new EventEmitter<void>();

  onDiscard(): void {
    this.discard.emit();
  }

  onValidate(): void {
    this.validate.emit();
  }

  onSecondary(): void {
    this.secondary.emit();
  }
}
